<div
    *ngIf="showRefinementPanel"
    id]="id"
    class="flex flex-col p-4 border-1 border-grey-600">

    <div class="flex flex-row justify-between items-center border-b border-b-gray-200 pb-2">
        <span class="body-large-bold">Filters</span>
        <button class="btn btn-link-blue" id="reset-filters" (click)="resetRefinements()">Reset</button>
    </div>

    @if (entityTypeRefinementDescriptor) {
        <app-search-refinement
            class="py-4 border-b border-b-grey-600 last:border-b-0"
            id="search-refinement-{{entityTypeRefinementDescriptor.name}}"
            [refinementDescriptor]="entityTypeRefinementDescriptor"
            [refinementRenderOptions]="refinementRenderOptions.get(entityTypeRefinementDescriptor.id)"
            [canExpandRefinement]="false"
        ></app-search-refinement>
    }

    <ng-container *ngFor="let item of refinementDescriptors">
        <app-search-refinement
            *ngIf="refinementRenderOptions.get(item.id)?.canRefine"
            class="py-4 border-b border-b-grey-200 last:border-b-0"
            id="search-refinement-{{item.name}}"
            [refinementDescriptor]="item"
            [refinementRenderOptions]="refinementRenderOptions.get(item.id)"
            [canExpandRefinement]="true"
        ></app-search-refinement>
    </ng-container>
</div>